/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// import { ReactComponent as TrashIcon } from 'Images/tool_trash.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 11px 11px 11px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
`;
Wrapper.displayName = 'Wrapper';
